/**
 * index  用户信息
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state = {
  freeTicket: 0, // 免费票剩余数量
  rechargeTicket: 0, // 充值票剩余数量
  vipSurplusDays: 0, // vip 剩余天数, 小于等于0 ,则无 vip
  integral: 0, // 积分数量
  monthCardNum: 0, //月卡剩余数量
  isLogin: false,  // 用户是否登录
  avatarUlr: null, // 用户头像
  phone: null, // 用户电话号码
  platform: null, // 用户平台
  sessionid: null, // 用户sessionid
  user_content: null, // 用户的个人信息 （userid等等）
  user_openid: null, // 用户的openid (微信用户才有)
  hasFreeUpdate: false, // 用户的月票信息弹框
  entranceAppname: '', // 如果是字节跳动小程序 是抖音还是头条的端口
  recentlyUser: [], // 用户最近常用的车牌号
}

export default {
  state,
  getters,
  actions,
  mutations
}




